import { markActionComplete } from 'user-context/onboarding';
import { IMPORT_DATA_ONBOARDING_TASKS } from '../constants/onboardingConstants';
export const markOnboardingTaskComplete = taskKey => {
  return markActionComplete(taskKey, {
    showTaskCompletionModal: false
  });
};
export const completeAllImportOnboardingTasks = () => {
  return Promise.all(IMPORT_DATA_ONBOARDING_TASKS.map(markOnboardingTaskComplete));
};